<template>
<footer class="footer">
  <div class="container-fluid">
    <img alt="logoFooter" src="../../assets/img/endesa.png">
  </div>
</footer>
</template>

<script>
export default {
    name:'common-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/footer/footer.vue